// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@hardwoods/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { generateTokenExFrameStyleConfig } from "@insite/mobius/TokenExFrame/TokenExFrameStyleConfig";
import get from "@insite/mobius/utilities/get";

const customGenerateTokenExFrameStyleConfig = (props: {
    theme: BaseTheme;
    sizeVariant?: "default" | "small";
    border?: "underline" | "rectangle" | "rounded";
    cssOverrides?: object;
}) => {
    const { theme } = props;
    const styles: ReturnType<typeof generateTokenExFrameStyleConfig> = generateTokenExFrameStyleConfig(props);
    styles.cvv.base = styles.base =
        `${styles.base}` +
        `display: block;` +
        `margin: auto;` +
        `width: calc(100% - 2px);` +
        `outline: 0;` +
        `background: ${get(theme, "colors.common.ui4")};` +
        `border-radius: 2px;` +
        `box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)({ theme })};` +
        `border: 1px solid ${get(theme, "colors.common.ui13")};`;
    styles.cvv.focus = styles.focus =
        `${styles.focus}` +
        `outline: 0;` +
        `border: 1px solid ${get(theme, "colors.common.ui13")};` +
        `padding: 0 10px;`;
    const dangerColor = get(theme, "colors.danger.main");
    styles.cvv.error = styles.error = `border-color: ${dangerColor}`;
    return styles;
};

export default customGenerateTokenExFrameStyleConfig;
